module.exports = __webpack_public_path__ + "images/stickers/huh.a57f2846cc60afe0d3e4.png";